//libraries
import Vue from 'vue'

let resource = 'product'
let resource_name = 'producto'
let resource_name_plural = 'productos'

let state = {
  all_products: []
}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      let mutation = params.list_all ? 'setAllProducts' : 'setItems'
      commit(mutation, [])
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit(mutation, res.data.resource.map(p => {
          p.error = false
          p.loading = false
          p.categories = []
          if (p.Categories) {
            p.categories = p.Categories.map(c => c.category_id)
          }
          if(params.currency) {
            let formater = new Intl.NumberFormat("es-MX", {style: "currency", currency: params.currency});
            p.formatted_price = formater.format(p.price)
          }
          if(p.Product_Variants && p.Product_Variants.length) {
            for (let i = 0; i < p.Product_Variants.length; i++) {
              let p_v = p.Product_Variants[i]
              p_v.variants = []
              p_v.Variant_Values.forEach(v_v => {
                p_v.variants.push(`${v_v.Variant.name}: ${v_v.value}`)
              })
              if(params.currency) {
                let formater = new Intl.NumberFormat("es-MX", {style: "currency", currency: params.currency});
                p_v.formatted_price = formater.format(p.price)
              }
              p_v.loading = false
            }
          }
          return p
        }))
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      console.log(res.data);
      if(res.data.success && params.callback) {
        let new_product = res.data.resource
        new_product.error = false
        new_product.categories = []
        if(res.data.resource.Categories) {
          new_product.categories = res.data.resource.Categories.map(c => c.category_id)
        }
        commit('pushProduct', new_product)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)

      if(res.data.success && params.callback) {
        let update_product = res.data.resource
        update_product.error = false
        update_product.categories = []
        if(res.data.resource.Categories) {
          update_product.categories = res.data.resource.Categories.map(c => c.category_id)
        }
        commit('replaceProduct', update_product)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeProduct', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  // ASSOCIATE CATEGORY TO PRODUCT
  async assignCategory ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/assignCategory`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error asociando categoria a ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error asociando categoria a ${resource_name}.`})
      console.error(e)
    }
  },
  // DISASSOCIATE CATEGORY FROM PRODUCT
  async removeCategory ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/removeCategory`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error desasociando categoria a ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error desasociando categoria a ${resource_name}.`})
      console.error(e)
    }
  },
  async upload ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/upload`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error subiendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error subiendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async update_upload ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/update_upload`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error subiendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error subiendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async variants ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/product_variants`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo variantes de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo variantes de ${resource_name}.`})
      console.error(e)
    }
  },
  async images ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/images`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo imágenes de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo imágenes de ${resource_name}.`})
      console.error(e)
    }
  },
  async image ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/image/${params.image_id}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo imagen.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo imagen.`})
      console.error(e)
    }
  },
  async createImage ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/image`, params)
      console.log(res.data)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando imagen.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando imagen.`})
      console.error(e)
    }
  },
  async updateImage ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/image/${params.image_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando imagen.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando imagen.`})
      console.error(e)
    }
  },
  async deleteImage ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}/image/${params.image_id}`, {data: params})
      console.log(res.data)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando imagen.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando imagen.`})
      console.error(e)
    }
  },
  async sendProduct ({ commit }, {callback,productId,params}) {
    try {
      let res = await Vue.request.post(`${resource}/${productId}/sendProduct`, params)
      if(!res.data.success)throw new Error('Error enviando producto') 
      callback(res.data)
    } catch (e) {
      console.error(e)
      if(!callback)return
      callback({error: e.message})
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  pushProduct (state, product) {
    state.products.push(product)
    state.all_products.push(product)
  },
  replaceProduct (state, product) {
    let index = state[resource + 's'].findIndex(p => p.product_id == product.product_id)
    if (index >= 0) {
      state.products.splice(index, 1, product)
    }
    index = state.all_products.findIndex(p => p.product_id == product.product_id)
    if (index >= 0) {
      state.all_products.splice(index, 1, product)
    }
  },
  removeProduct (state, product) {
    let index = state[resource + 's'].findIndex(p => p.product_id == product.product_id)
    if (index >= 0) {
      state.products.splice(index, 1)
    }
    index = state.all_products.findIndex(p => p.product_id == product.product_id)
    if (index >= 0) {
      state.all_products.splice(index, 1)
    }
  },
  setAllProducts (state, items) {
    state.all_products = items
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
